<template>
  <section class="section is-marginless" style="padding-top: 22px">
    <div>
      <div class="columns is-centered">
        <div class="column is-half">
          <h4 class="page-title add-organization-text">Add an organization</h4>
        </div>
      </div>

      <div class="columns is-centered">
        <div class="column is-half">
          <div calss="">
            <b-field class="" label="Salesforce Account ID *">
              <b-input
                required
                size="is-medium"
                placeholder="i.e., 45681746"
                ref="billing_provider_account_id"
                v-model="organization.billing_provider_account_id"
              >
              </b-input>
            </b-field>
          </div>
        </div>
      </div>

      <div class="columns is-centered">
        <div class="column is-half">
          <div calss="input-box-wrapper">
            <b-field class="" label="Organization name *">
              <b-input
                size="is-medium"
                required
                placeholder="Organization name"
                ref="name"
                v-model="organization.name"
              ></b-input>
            </b-field>
          </div>
        </div>
      </div>

      <div class="columns is-centered">
        <div class="column is-half full-address">
          <b-field label="Full Address *" :type="this.isValidAddress ? null : 'is-danger'">
            <b-autocomplete
              v-on:input="handleAutoCompleteAddress()"
              ref="address"
              :data="autoCompletes"
              placeholder="Full address"
              required
              field="description"
              :loading="isFetching"
              @typing="onAddressChange"
              @select="option => (organization.address = option.description)"
              icon-pack="fas"
              icon="search"
              size="is-medium"
            >
              <template slot-scope="props">
                <div class="media">
                  <div>
                    {{ props.option.description }}
                  </div>
                </div>
              </template>
            </b-autocomplete>
          </b-field>
        </div>
      </div>

      <div class="columns is-centered">
        <div class="column is-half">
          <div calss="input-box-wrapper">
            <b-field class="" label="Email address *">
              <b-input
                size="is-medium"
                placeholder="name@email.com"
                required
                ref="email"
                v-model="organization.email"
              ></b-input>
            </b-field>
          </div>
        </div>
      </div>

      <div class="columns is-centered">
        <div class="column is-half">
          <div calss="input-box-wrapper">
            <b-field class="contact-phone-number" label="Contact phone number *" :type="organization.phone ? null : required">
              <PhoneCountryPicker ref="phone_country_picker">
              </PhoneCountryPicker>
              <b-input
                size="is-medium"
                placeholder="1234567890"
                ref="phone"
                required
                v-model="organization.phone"
                expanded
              ></b-input>
            </b-field>
          </div>
        </div>
      </div>

      <div class="columns is-centered">
        <div class="column is-half">
          <div class="pull-right">
            <a class="create-button"
              @click="save" :disabled="!isValidate">
              <div>Create organization</div>
            </a>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import LocationService from "../location/service";
import PhoneCountryPicker from "@/components/common/PhoneCountryPicker";
import { ToastProgrammatic as Toast } from "buefy";
import CompanyService from "./service";
export default {
  name: "OrganizationSignup",
  components: {
    PhoneCountryPicker
  },

  props: ["prvStep"],

  data() {
    return {
      organization: {
        external_reference: "",
        name: "",
        address: "",
        email: "",
        phone: "",
        phone_country: ""
      },
      autoCompletes: [],
      validate: 0,
      isFetching: false,
      selected: null,
      isValidAddress: true,
    };
  },

  computed: {
    isValidate() {
      let is_disable =
        this.organization.billing_provider_account_id != "" &&
        this.organization.name != "" &&
        this.organization.email != "" &&
        this.organization.phone != "" &&
        this.organization.phone.length === 10 &&
        this.organization.address != "" &&
        this.isValidAddress;
      return is_disable;
    }
  },

  methods: {
    back() {
      this.$emit("step", 0);
    },

    handleAutoCompleteAddress() {
      this.isValidAddress = false;
      this.autoCompletes.forEach((address) => {
        if(address.description === this.organization.address){
          this.isValidAddress = true;
        }
      })
    },

    onAddressChange: _.debounce(async function(value) {
      if (!value) {
        this.autoCompletes = [];
        return;
      }
      this.isFetching = true;
      try {
        const response = await LocationService.getAutoComplete(value);
        this.autoCompletes = response.predictions;
        this.isFetching = false;
      } catch (err) {
        console.log("error", err);
        this.autoCompletes = [];
        this.isFetching = false;
      }
    }, 300),

    save() {
      if (!this.organization.billing_provider_account_id) {
        this.$refs.billing_provider_account_id.focus();
        return this.throwError("Invalid salesforce account ID");
      }
      
      if (!this.organization.name) {
        this.$refs.name.focus();
        return this.throwError("Invalid name");
      }

      if (!this.organization.address || !this.isValidAddress) {
        this.isValidAddress = false;
        this.$refs.address.focus();
        return this.throwError("Invalid address");
      }

      if (!this.organization.email) {
        this.$refs.email.focus();
        return this.throwError("Invalid email");
      }

      this.organization.phone_country = this.$refs.phone_country_picker.selected_country.code;
      if (!this.organization.phone_country) {
        return this.throwError("Please select a phone coutry");
      }

      if (!this.organization.phone) {
        this.$refs.phone.focus();
        return this.throwError("Invalid phone");
      }

      CompanyService.createOrganization(
        this.organization,
        (err, organization) => {
          if (err) {
            Toast.open({ type: "is-danger", message: err.message });
            return;
          }

          this.$emit("step", { step: 2, prvStep: 1 });

          Toast.open({
            type: "is-success",
            message: `Organization signup successful`
          });
        }
      );
    },

    throwError(message) {
      this.is_loading = false;
      Toast.open({ type: "is-danger", message });
    }
  }
};
</script>

<style lang="css">
.add-organization-text {
    width: 260px;
    height: 32px;
    line-height: 32px;
    letter-spacing: -0.09px;
    text-align: left !important;
}

.input-box-container {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    padding: 0px 0px 16px;
    gap: 16px;
    width: 451px;
    height: 420px;
    flex: none;
    order: 2;
    align-self: stretch;
    flex-grow: 0;
    margin-top: 16px;
}

.input-box-container .field {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    padding: 0px;
    gap: 8px;
    width: 451px;
    height: 68px;
    flex: none;
    order: 0;
    align-self: stretch;
    flex-grow: 0;
}

.input-box-container .label {
    width: 419px;
    height: 20px;
    font-family: 'CircularXX';
    font-style: normal;
    font-weight: 500;
    font-size: 18.75px;
    line-height: 20px;
    color: #252935;
    flex: none;
    order: 0;
    flex-grow: 0;
}

.create-button[disabled] {
    display:flex;
    margin-right: 0;
    margin-left:auto;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    padding: 10px 16px;
    gap: 8px;
    width: 160px;
    height: 48px;
    background: #99EBE5;
    opacity: 0.5;
    border-radius: 32px;
    border: none;
    flex: none;
    order: 0;
    flex-grow: 0;
}

.create-button>div {
    font-family: 'CircularXX';
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 20px;
    text-align: center;
    color: #252935;
    flex: none;
    order: 0;
    flex-grow: 0;
}

.create-button {
    display: flex;
    margin-right: 0;
    margin-left:auto;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    padding: 10px 16px;
    gap: 8px;
    width: 160px;
    height: 48px;
    background: #99EBE5;
    border-radius: 32px;
    border: none;
    flex: none;
    order: 0;
    flex-grow: 0;
}

::placeholder {
    font-family: 'CircularXX';
    font-style: normal;
    font-weight: 400;
    font-size: 18.75px;
    color: #A5A9B1 !important;
}

#select_id {
    font-family: 'CircularXX' !important;
    font-style: normal;
    font-weight: 400;
    color: #A5A9B1 !important;

}
</style>



// WEBPACK FOOTER //
// src/components/company/OrganizationSignup.vue